export default "__VITE_ASSET__38279122__"